/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { HrFlexContainer, HrGrey, HrlighterGrey, HrParagraph, Spinner } from '@components/styles/hr-styles';
import { EmptyData } from '../../images/empty-data-table';

const TableFlexContainer = styled(HrFlexContainer)`
  background-color: #fff;
`;

const TableWrapper = styled(HrFlexContainer)`
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar-thumb {
    background: ${HrlighterGrey};
    border-radius: 10px;
    &:hover {
      background-color: ${HrGrey};
    }
  }
  &::-webkit-scrollbar,
  &::-webkit-scrollbar-thumb {
    height: 6px;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0px;
    background: transparent;
  }
`;

const TableContainer = styled.table`
  width: 100%;
`;

const TableHead = styled.thead`
  background: #3b3f51;
  border-radius: 6px;
  color: #fff;
`;

const TableRow = styled.tr``;

const TableHeader = styled.th`
  padding: 12px;
  white-space: nowrap;
  font-weight: 600;

  & i {
    color: white;
    font-size: 16px;
    vertical-align: text-bottom;
  }
`;

const TableBody = styled.tbody``;

const TableData = styled.td`
  padding: 16px;
  & > div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const GenericTable = ({ tableInstance, isLoading, isError, emptyMessage, dataIntercomTarget }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
  const isSorted = (column) => {
    if (column.isSorted) {
      if (column.isSortedDesc) return <i className='hr-Order-Down' />;
      if (!column.isSortedDesc) return <i className='hr-Order-Up' />;
    }
    return <i className='hr-Order' />;
  };
  return (
    <TableFlexContainer>
      <TableWrapper>
        <TableContainer {...getTableProps()}>
          <TableHead data-intercom-target={dataIntercomTarget ?? 'Tabla'}>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) =>
                  column.id === 'Actions' ? (
                    <TableHeader {...column.getHeaderProps()}>{column.render('Header')}</TableHeader>
                  ) : (
                    <TableHeader {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {isSorted(column)}
                      {column.render('Header')}
                    </TableHeader>
                  )
                )}
              </TableRow>
            ))}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);

              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <TableData {...cell.getCellProps()}>
                      <div>{cell.render('Cell')}</div>
                    </TableData>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </TableContainer>
      </TableWrapper>
      {isLoading && <Spinner className='hr-Charge' style={{ margin: '0 auto', fontSize: '16px', color: '#9a9a9a' }} />}
      {!isLoading && rows.length === 0 && (
        <HrFlexContainer flexDirection='column'>
          <div style={{ width: '100px', margin: '16px auto' }}>{EmptyData}</div>
          <HrParagraph textAlign='center '>{emptyMessage}</HrParagraph>
        </HrFlexContainer>
      )}
    </TableFlexContainer>
  );
};
